/**
 * import topicsDir from "../__topicsDir";
*/

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2025-01-21T11:00",
		title: `
		<h4>新潟県医師会在宅医療推進センターより</h4>
		<p class="paragraph-indent">●新潟県在宅医療推進センターコーディネーター研修会を１月８日（水）に開催いたしました。<br>
		医療経済研究機構　専門研究員　松本佳子様を講師に迎え、ロジックモデルの考え方と医療計画在宅医療分野について理解を深めました。<br>
		研修会前半の講義はWEB配信により市町村ご担当者にも広くご視聴いただき、後半のグループワークでは新潟県保健医療計画を読み解き、センター事業計画のセオリー評価に取り組みました。
		</p>
		<div class="imageBox-3">
		<ul><li><img src="../../../zaitaku/contents/topics/2025/01-001/img01.png" alt="新潟県在宅医療推進センターコーディネーター研修会の様子"></li></ul>
		<ul><li><img src="../../../zaitaku/contents/topics/2025/01-001/img02.png" alt="新潟県在宅医療推進センターコーディネーター研修会の様子"></li></ul>
		</div>
		`
		.trim()
		.replace(/\t|\n/g, ""),
	},
];
